function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhoneRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.595 19.27l-2.39 2.39a1.101 1.101 0 01-1.2.244c-1.091-.448-3.256-1.468-4.848-3.06-1.593-1.594-2.613-3.759-3.061-4.85a1.103 1.103 0 01.244-1.2l2.39-2.389a2.217 2.217 0 000-3.133L8.109 2.648a2.215 2.215 0 00-3.134 0L2.65 4.973A2.221 2.221 0 002 6.601c.064 2.778.005 10.098 6.654 16.745 6.648 6.65 13.967 6.59 16.746 6.652a2.217 2.217 0 001.627-.648l2.324-2.324a2.216 2.216 0 000-3.134l-4.622-4.622a2.217 2.217 0 00-3.134 0z",
    fill: props.color
  }));
}

export default SvgIconPhoneRexFilled;